import { capitalize } from '$utils/text'

import { profile as profileModel } from './profile.js'

export const getUser = () => {
  return window.UFE.user
}

export const getFullName = (user = {}, short = false) => {
  if (short) {
    if (user && user.first_name && user.first_name !== '') {
      return user.first_name
    }
  }

  if (user && user.screenname) {
    return user.screenname
  }

  if (user && user.first_name && user.first_name !== '' && user.last_name && user.last_name !== '') {
    return user.first_name + ' ' + user.last_name
  }

  if (user && user.username) {
    return user.username
  }

  return user && user.name
}

// if there is no first name we fallback on full name
const getFirstName = user => {
  if (user.first_name) {
    return user.first_name
  }

  return getFullName(user)
}

const getShortName = (user = {}) => {
  let shortname

  if (user.first_name && user.last_name) {
    shortname = `${capitalize(user.first_name)} ${capitalize(user.last_name.substr(0, 1))}.`
  } else {
    shortname = user.screenname || user.name
  }

  return shortname
}

const getAvatar = user => (size = 'full') => {
  if (user.avatar && user.avatar.versions) {
    return user.avatar.versions[size]
  }
}

const getTotalProjectCreates = owner => {
  if (owner && owner.stats) {
    const stats = Object.values(owner.stats)
    return stats.reduce((acc, curr) => acc + curr)
  }

  return null
}

function isAuthenticated(user) {
  return user && user.is_authenticated
}

const user = (user = {}) => {
  return {
    ...user,
    fullname: getFullName(user),
    shortname: getShortName(user),
    getAvatar: getAvatar(user),
    firstName: getFirstName(user),
    isAuthenticated: isAuthenticated(user),
    totalProjectCreated: getTotalProjectCreates(user),
    profile: profileModel(user)
  }
}

export default user
